import type { GcsPath } from "@/components/common/GcsImage";

interface Leader {
  name: string;
  title: string;
  email?: string;
  slug: string;
  image: GcsPath;
  license?: string;
}
export const leadershipTeam: Leader[] = [
  {
    name: "Zach Clayton",
    title: "Co-Founder & CEO",
    email: "zach.clayton@guardianservice.com",
    slug: "zach-clayton",
    image: "images/about/leader-zach-clayton.webp",
    license: "21451401",
  },
  {
    name: "John Clayton",
    title: "Co-Founder & Chief Growth Officer",
    email: "john.clayton@guardianservice.com",
    slug: "john-clayton",
    image: "images/about/leader-john-clayton.webp",
    license: "21664312",
  },
  {
    name: "Ana Berrizbeitia",
    title: "Member Experience",
    email: "ana.berrizbeitia@guardianservice.com",
    slug: "ana-berrizbeitia",
    image: "images/careers/Shield - Ana Berrizbeitia.webp",
  },
  {
    name: "Jeff Boyer",
    title: "Member Experience",
    email: "jeff.boyer@guardianservice.com",
    slug: "jeff-boyer",
    image: "images/about/leader-jeff-boyer.webp",
    license: "21615747",
  },
  {
    name: "Heath Bradbury",
    title: "Marketing",
    email: "heath.bradbury@guardianservice.com",
    slug: "heath-bradbury",
    image: "images/about/leader-heath-bradbury.webp",
    license: "21469016",
  },
  {
    name: "Elizabeth Bunn",
    title: "Talent",
    email: "elizabeth.bunn@guardianservice.com",
    slug: "elizabeth-bunn",
    image: "images/about/leader-elizabeth-bunn.webp",
  },
  {
    name: "Evan Burns",
    title: "Partnerships",
    email: "evan.burns@guardianservice.com",
    slug: "evan-burns",
    image: "images/about/leader-evan-burns.webp",
    license: "22143219",
  },
  {
    name: "Jeremy Chasak",
    title: "Member Experience",
    email: "jeremy.chasak@guardianservice.com",
    slug: "jeremy-chasak",
    image: "images/about/leader-jeremy-chasak.webp",
    license: "18514276",
  },
  {
    name: "Shivalika Chaudhary",
    title: "Technology",
    email: "shivalika.chaudhary@guardianservice.com",
    slug: "shivalika-chaudhary",
    image: "images/careers/Shield - Shivalika Chaudhary.webp",
  },
  {
    name: "Kara Credle",
    title: "Member Engagement",
    email: "kara.credle@guardianservice.com",
    slug: "kara-credle",
    image: "images/about/leader-kara-credle.webp",
    license: "21449125",
  },
  {
    name: "Sierra Dodds",
    title: "Member Experience",
    email: "sierra.dodds@guardianservice.com",
    slug: "sierra-dodds",
    image: "images/about/leader-sierra-dodds.webp",
    license: "21742793",
  },
  {
    name: "Patrick Fedroff",
    title: "Sales",
    email: "patrick.fedroff@guardianservice.com",
    slug: "patrick-fedroff",
    image: "images/about/leader-patrick-fedroff.webp",
  },
  {
    name: "Tim Ferreira",
    title: "Sales",
    email: "tim.ferreira@guardianservice.com",
    slug: "tim-ferreira",
    image: "images/careers/Shield - Tim F.webp",
    license: "19605624",
  },
  {
    name: "Minda Flores",
    title: "Member Experience",
    email: "arminda.flores@guardianservice.com",
    slug: "minda-flores",
    image: "images/careers/Shield - Minda Flores.webp",
    license: "16857660",
  },
  {
    name: "Walker Fuller",
    title: "Finance",
    email: "walker.fuller@guardianservice.com",
    slug: "walker-fuller",
    image: "images/about/leader-walker-fuller.webp",
  },
  {
    name: "Liz Galarza",
    title: "Sales",
    email: "liz.galarza@guardianservice.com",
    slug: "liz-galarza",
    image: "images/about/leader-liz-galarza.webp",
    license: "14943179",
  },
  {
    name: "Seth Garff",
    title: "Strategy",
    email: "seth.garff@guardianservice.com",
    slug: "seth-garff",
    image: "images/about/leader-seth-garff.webp",
    license: "21638633",
  },
  {
    name: "Billy Gerhard",
    title: "Technology & Data",
    email: "billy.gerhard@guardianservice.com",
    slug: "billy-gerhard",
    image: "images/about/leader-billy-gerhard.webp",
  },
  {
    name: "Marc Gross",
    title: "Sales",
    email: "marc.gross@guardianservice.com",
    slug: "marc-gross",
    image: "images/about/leader-marc-gross.webp",
    license: "7538729",
  },
  {
    name: "Mary Hahn",
    title: "People",
    email: "mary.hahn@guardianservice.com",
    slug: "mary-hahn",
    image: "images/about/leader-mary-hahn.webp",
    license: "21612810",
  },
  {
    name: "Peyton Helou",
    title: "Talent Acquisition",
    email: "peyton.helou@guardianservice.com",
    slug: "peyton-helou",
    image: "images/about/leader-peyton-helou.webp",
  },
  {
    name: "Meena Kaundinya",
    title: "Marketing",
    email: "meena.kaundinya@guardianservice.com",
    slug: "meena-kaundinya",
    image: "images/careers/Shield - Meena Kaundinya.webp",
  },
  {
    name: "Rachel Kelsey",
    title: "Talent Acquisition",
    email: "rachel.kelsey@guardianservice.com",
    slug: "rachel-kelsey",
    image: "images/careers/Shield - Rachel Kelsey.webp",
  },
  {
    name: "Julian Labossiere",
    title: "Sales",
    email: "julian.labossiere@guardianservice.com",
    slug: "julian-labossiere",
    image: "images/careers/Shield - Julian L.webp",
    license: "1144469",
  },
  {
    name: "Lacy Martin",
    title: "Strategy & Operations",
    email: "lacy.martin@guardianservice.com",
    slug: "lacy-martin",
    image: "images/about/leader-lacy-martin.webp",
  },
  {
    name: "Luke Mitchell",
    title: "Partnerships",
    email: "luke.mitchell@guardianservice.com",
    slug: "luke-mitchell",
    image: "images/about/leader-luke-mitchell.webp",
    license: "22120785",
  },
  {
    name: "Tommy Noles",
    title: "Member Experience",
    email: "tommy.noles@guardianservice.com",
    slug: "tommy-noles",
    image: "images/about/leader-tommy-noles.webp",
  },
  {
    name: "Molly O'Connor",
    title: "Community Impact",
    email: "molly.oconnor@three-ships.com",
    slug: "molly-oconnor",
    image: "images/about/leader-molly-oconnor.webp",
  },
  {
    name: "Robbie O'Han",
    title: "Finance",
    email: "robbie.ohan@guardianservice.com",
    slug: "robbie-ohan",
    image: "images/careers/Shield - Robbie O.webp",
  },
  {
    name: "Carlos Patiño",
    title: "Technology",
    email: "carlos.patino@guardianservice.com",
    slug: "carlos-patino",
    image: "images/about/leader-carlos-patino.webp",
  },
  {
    name: "Joan Pierce",
    title: "Accounting",
    email: "joan.pierce@guardianservice.com",
    slug: "joan-pierce",
    image: "images/about/leader-joan-pierce.webp",
  },
  {
    name: "Emma Reid",
    title: "Member Experience",
    email: "emma.reid@guardianservice.com",
    slug: "emma-reid",
    image: "images/careers/Shield - Emma Reid.webp",
  },
  {
    name: "Jack Rodriguez",
    title: "Operations",
    email: "jack.rodriguez@guardianservice.com",
    slug: "jack-rodriguez",
    image: "images/about/leader-jack-rodriguez.webp",
    license: "21676225",
  },
  {
    name: "Mike Schmitt",
    title: "Sales",
    email: "mike.schmitt@guardianservice.com",
    slug: "mike-schmitt",
    image: "images/about/leader-mike-schmitt.webp",
    license: "16800721",
  },
  {
    name: "Lauren Schwenk",
    title: "Creative",
    email: "lauren.schwenk@guardianservice.com",
    slug: "lauren-schwenk",
    image: "images/about/leader-lauren-schwenk.webp",
    license: "21612941",
  },
  {
    name: "Mitch Stella",
    title: "Talent Acquisition",
    email: "mitch.stella@guardianservice.com",
    slug: "mitch-stella",
    image: "images/about/leader-mitch-stella.webp",
    license: "1641836",
  },
  {
    name: "Shawn Terrell",
    title: "Member Experience",
    email: "shawn.terrell@guardianservice.com",
    slug: "shawn-terrell",
    image: "images/careers/Shield - Shawn Terrell.webp",
    license: "7977965",
  },
  {
    name: "Dana Wallace",
    title: "Finance",
    email: "dana.wallace@guardianservice.com",
    slug: "dana-wallace",
    image: "images/about/leader-dana-wallace.webp",
  },
  {
    name: "Jackson Waller",
    title: "Data",
    email: "jackson.waller@guardianservice.com",
    slug: "jackson-waller",
    image: "images/about/leader-jackson-waller.webp",
  },
  {
    name: "Kristi Ware",
    title: "Sales",
    email: "kristi.ware@guardianservice.com",
    slug: "kristi-ware",
    image: "images/about/leader-kristi-ware.webp",
    license: "12484044",
  },
  {
    name: "Lindsey Yannoni",
    title: "Member Experience",
    email: "lindsey.yannoni@guardianservice.com",
    slug: "lindsey-yannoni",
    image: "images/about/leader-lindsey-yannoni.webp",
    license: "21453357",
  },
];

export const board: Leader[] = [
  {
    name: "Rasesh Patel",
    title: "Board of Directors",
    slug: "rasesh-patel",
    image: "images/about/leader-rasesh-patel.webp",
  },
  {
    name: "Michael Stahl",
    title: "Board of Directors",
    slug: "mike-stahl",
    image: "images/about/leader-mike-stahl.webp",
  },
  {
    name: "John Thornton",
    title: "Board of Directors",
    slug: "john-thornton",
    image: "images/about/leader-john-thornton.webp",
  },
];

export interface LeaderData {
  name: string;
  title: string;
  email?: string;
  linkedin: string;
  image: GcsPath;
  bio: string;
  education: string;
  expertise?: string;
  credentials?: string;
  passion?: string;
  quote: string;
  quoteAuthor: string;
}

export const leaders: Record<string, LeaderData> = {
  "jeff-boyer": {
    name: "Jeff Boyer",
    title: "Chief Member Officer",
    email: "jeff.boyer@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/jeff-boyer-208a778/",
    image: "images/about/leader-jeff-boyer.webp",
    bio: "Jeff is a licensed personal lines insurance producer based in Raleigh, North Carolina and leads the Guardian Service Member Experience team. His personal mission is for every member to have such a great experience, they can't help but tell all their friends. Prior to Guardian Service, Jeff was an executive at Wayfair, a leader in Bain & Co.'s Private Equity Practice and founded a real estate agent marketplace.",
    education:
      "B.S.E., Biomedical Engineering and Economics at Duke University; MBA at Harvard Business School",
    expertise:
      "Home and Auto Insurance, Umbrella Policies, Policy Changes, Endorsements",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion: "Keeping up with his seven year old",
    quote: "There is only one boss. The customer.",
    quoteAuthor: "Sam Walton",
  },
  "elizabeth-bunn": {
    name: "Elizabeth Bunn",
    title: "Head of Executive Recruiting",
    email: "elizabeth.bunn@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/elizabeth-bunn-873b4a164/",
    image: "images/about/leader-elizabeth-bunn.webp",
    bio: "Elizabeth leads recruitment for Guardian Service. She stays connected with insurance leaders across multiple industries and brings years of experience recruiting and leading organizational design for the other Three Ships businesses. She is passionate about identifying exceptional talent, building great teams across the business, and supporting our teams as we continue to grow and scale.",
    education: "B.A, Communications & German at Wake Forest University",
    expertise: "Executive Recruitment, Insurance Leadership",
    credentials: "",
    passion: "Traveling to new places",
    quote: "Always give your best effort even when the odds are against you.",
    quoteAuthor: "Arnold Palmer",
  },
  "evan-burns": {
    name: "Evan Burns",
    title: "Director of Partnerships",
    email: "evan.burns@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/evangburns/",
    image: "images/about/leader-evan-burns.webp",
    bio: "Evan is the Director of Partnerships at Guardian Service, where he brings a decade of experience driving revenue growth for real estate and mortgage professionals. He's on a mission to build meaningful relationships that make a lasting impact on Concierge Partners, their business, and the clients they serve.",
    education: "B.S., Marketing at Clemson University",
    expertise:
      "Partnerships, Building and Scaling Strategic Relationships, Driving Revenue Growth",
    credentials: "",
    passion: "The only thing that beats a ski trip is a golf trip",
    quote:
      "Maybe I can't change the world, but I know I can change someone's world, and that's all that matters to me.",
    quoteAuthor: "Katie Davis",
  },
  "shivalika-chaudhary": {
    name: "Shivalika Chaudhary",
    title: "AI-Native Software Engineer",
    email: "shivalika.chaudhary@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/shivalika-chaudhary/",
    image: "images/careers/Shield - Shivalika Chaudhary.webp",
    bio: "Shivalika is a software engineer with experience across large-scale systems, cloud infrastructure, and building with AI. She likes cutting through complexity to build solutions that are clean, scalable, and built to last. She is originally from Mumbai, India.",
    education:
      "B.Tech., Computer Science at Manipal Institute of Technology; M.S., Computer Science at The University of Chicago",
    expertise:
      "Backend systems, software engineering, high-performance computing",
    credentials: "",
    passion: "Chasing good food and coffee, biking, and exploring new places",
    quote: "Simplicity is the ultimate sophistication.",
    quoteAuthor: "Leonardo da Vinci",
  },
  "john-clayton": {
    name: "John Clayton",
    title: "Co-Founder & Chief Growth Officer",
    email: "john.clayton@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/johnclayton/",
    image: "images/about/leader-john-clayton.webp",
    bio: "John is a co-founder and licensed insurance producer based in Atlanta. He brings 15+ years of business-building and entrepreneurial expertise to Guardian Service. He's on a mission to help you permanently cross insurance shopping off your 'to do' list.",
    education:
      "B.A., Economics & Chinese at Wake Forest University; MBA at Harvard Business School",
    expertise: "Car insurance, Home insurance, Partnerships, Member experience",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion: 'Big language nerd — I can say "savings" in 8 different languages',
    quote: "It's like the more money we come across, the more problems we see.",
    quoteAuthor: "Notorious B.I.G.",
  },
  "zach-clayton": {
    name: "Zach Clayton",
    title: "Co-Founder & CEO",
    email: "zach.clayton@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/zachclayton/",
    image: "images/about/leader-zach-clayton.webp",
    bio: "Zach is the CEO and Co-Founder of Guardian Service, where he leads the company's strategy to reimagine the independent insurance brokerage using technology and data-driven insights. As a licensed agent, Zach combines hands-on industry knowledge with a long-term vision to make home protection simpler and smarter for homeowners nationwide.\n\nHe is also the Founder and CEO of Three Ships, a digital platform company that builds and scales category-leading businesses such as Home Solutions, Home Energy Club, and Pillar4 Media. Zach's career has been centered on helping organizations grow faster by blending operational excellence and digital innovation.",
    education:
      "M.B.A., George F. Baker Scholar at Harvard Business School; B.A., Economics, Morehead Scholar, Phi Beta Kappa at University of North Carolina at Chapel Hill",
    expertise:
      "Digital Marketing, Entrepreneurship, Customer Acquisition, Brand Strategy, Mergers & Acquisitions, Leadership",
    credentials: "Home, Auto, Umbrella, and Utility Line Warranty",
    passion: "Family, Education, Golf",
    quote:
      "Don't let the noise of others' opinions drown out your inner voice.",
    quoteAuthor: "Bill George",
  },
  "patrick-fedroff": {
    name: "Patrick Fedroff",
    title: "Sales Manager",
    email: "patrick.fedroff@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/patrick-fedroff-87497130",
    image: "images/about/leader-patrick-fedroff.webp",
    bio: "Patrick is a licensed personal lines insurance Sales Manager from Hillsborough, New Jersey. He brings more than a decade of experience leading and scaling high-performing sales and operations teams. His leadership philosophy is anchored in performance excellence, collaborative team-building, and a shared passion for driving meaningful, positive change across the insurance industry.",
    education:
      "B.A., Communication Studies and minors in Entrepreneurship and Advertising at West Virginia University",
    expertise:
      "Car Insurance, Home Insurance, Umbrella Policies, Utility Line Warranties",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion:
      "Dogs, raising my daughter, sports, craft beer, and Pickleball in no particular order",
    quote:
      "They say raising a daughter is hard, but if you never say no and give them everything they want, it's actually pretty easy.",
    quoteAuthor: "",
  },
  "tim-ferreira": {
    name: "Tim Ferreira",
    title: "Sales Manager",
    email: "tim.ferreira@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/timothy-ferreira/",
    image: "images/careers/Shield - Tim F.webp",
    bio: "Tim is an accomplished sales leader from Westport Massachusetts, leading large teams in insurance. Tim is licensed in Property & Casualty, as well as Life Insurance. He brings experience specializing teams in insurance from household names such as GEICO and AAA. He is passionate about building successful sales teams, and leads with the philosophy of \"You can only manage that which you measure\". Outside of work, Tim is a family man, and a car guy. He spends his weekends enjoying the coastal life of Westport with his family, and tinkering with cars.",
    education:
      "Advanced Automotive Technology at New England Institute of Technology",
    expertise:
      "Home & Auto Insurance, Life Insurance, Landlord Policies, High-Value Property Insurance",
    credentials:
      "Licensed Insurance Producer in Property & Casualty, and Life Insurance. Currently working towards CIC designation.",
    passion:
      "Enjoying time with my wife and 2 daughters, as well as working on cars.",
    quote:
      "Some people want it to happen, some wish it would happen, and others make it happen.",
    quoteAuthor: "Michael Jordan",
  },
  "walker-fuller": {
    name: "Walker Fuller",
    title: "Chief Financial Officer",
    email: "walker.fuller@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/walker-fuller-b6084084/",
    image: "images/about/leader-walker-fuller.webp",
    bio: "Walker is a finance leader from North Carolina. He has extensive experience helping businesses with strategy, capital allocation, and financial planning. He loves working on tough analytical problems and finding better ways to help members navigate the insurance ecosystem.",
    education: "B.A., History at UNC-Chapel Hill; MBA at Stanford",
    expertise: "Finance, Strategy, M&A",
    credentials: "",
    passion: "Getting first chair on a powder day",
    quote: "And now that you don't have to be perfect, you can be good.",
    quoteAuthor: "Steinbeck",
  },
  "billy-gerhard": {
    name: "Billy Gerhard",
    title: "Chief Technology Officer",
    email: "billy.gerhard@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/bgerhard/",
    image: "images/about/leader-billy-gerhard.webp",
    bio: "Billy is the Chief Technology Officer and is tasked with improving operations efficiency via technology. Before Guardian Service, he was a Partner at Boston Consulting Group where he focused on building digital tools to improve operations for clients in various industries. He also earned a PhD at Duke University where he applied machine learning to identify characteristics that could be used to classify water samples as treated or untreated. He thrives on identifying and eliminating friction in processes to improve the Guardian Service experience for our teammates and customers.",
    education:
      "BS, Biology at UNC-Chapel Hill; MSPH in Environment Sciences and Engineering at UNC-Chapel Hill, PhD in Civil and Environmental Engineering at Duke University",
    expertise: "Applied AI/ML, Data science and analytics, Data visualization",
    credentials: "PhD from Duke University",
    passion: "Spending time outdoors",
    quote:
      "There is nothing quite so useless, as doing with great efficiency, something that should not be done at all.",
    quoteAuthor: "Peter Drucker",
  },
  "marc-gross": {
    name: "Marc Gross",
    title: "Sales Manager",
    email: "marc.gross@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/marc-gross-b2508428/",
    image: "images/about/leader-marc-gross.webp",
    bio: "Born and raised in New York, Marc relocated to Florida where he earned his degree from UCF. Marc is a sales leader with 20+ years of experience growing revenue, building strong teams, and helping clients find the solutions they need. At Guardian Service, Marc drives sales strategy and growth, building on a proven track record at Steadily and Liberty Mutual Insurance. Marc loves mentoring teams, tackling challenges, and turning opportunities into wins.",
    education: "B.A., English at University of Central Florida",
    expertise:
      "Auto, Home, Condo, Renters, Landlord, Umbrella, Watercraft, Personal Articles Floater, etc.",
    credentials:
      "Licensed Insurance Producer, P&C; Associate in Insurance (AINS)",
    passion:
      "Powered by coffee and good vibes, I enjoy spending time with my family, traveling, movies, music, and watching sports. Go Cowboys and Yankees!",
    quote: "The only way to do great work is to love what you do.",
    quoteAuthor: "Steve Jobs",
  },
  "mary-hahn": {
    name: "Mary Hahn",
    title: "Chief People Officer",
    email: "mary.hahn@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/marygyhahn/",
    image: "images/about/leader-mary-hahn.webp",
    bio: "Mary is a licensed personal lines insurance producer and the leader of the Guardian Service agent team. With a deep background in corporate and business unit strategy, innovation, and strategic finance, Mary plays a key role in creating the best sales experience in insurance.",
    education:
      "B.A., English & Government at University of Texas; MBA at Duke University",
    expertise:
      "Car Insurance, Home Insurance, Umbrella Policies, Utility Line Warranties",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion: "Entertaining toddlers (mostly her own)",
    quote:
      "If you look good, you feel good. If you feel good, you play good. If you play good, they pay good.",
    quoteAuthor: "Deion Sanders",
  },
  "julian-labossiere": {
    name: "Julian Labossiere",
    title: "Sales Manager",
    email: "julian.labossiere@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/julian-l-57a38b214/",
    image: "images/careers/Shield - Julian L.webp",
    bio: "Julian is an insurance sales leader from Long Island, New York, with extensive experience across personal and commercial lines sales, marketing, operations, and team leadership. He has led high-performing sales organizations, built scalable processes, and developed coaching strategies designed to improve conversion, accountability, and customer experience. He brings a practical, growth-focused approach to building teams, solving operational challenges, and driving results.",
    education: "B.B.A. at New York Institute of Technology (NYIT)",
    expertise:
      "Personal Lines Insurance, Commercial Lines Insurance, Life Insurance, High-Net-Worth Coverage, Sales Leadership, Insurance Operations, Sales Coaching, Pipeline Management, and Growth Strategy",
    credentials: "Licensed Property & Casualty Insurance Producer",
    passion:
      "Playing guitar, traveling, mastering the perfect pizza recipe, and trying to keep up with my son.",
    quote: "Life is too short to do the things you don't love doing.",
    quoteAuthor: "Bruce Dickinson",
  },
  "lacy-martin": {
    name: "Lacy Martin",
    title: "Growth Strategy & Operations",
    email: "lacy.martin@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/lacymmartin/",
    image: "images/about/leader-lacy-martin.webp",
    bio: "Lacy focuses on growth strategy and operations at Guardian Service, helping drive scalable, data-informed growth across the business. Before Guardian Service, she lived in the UK while pursuing her MBA. ",
    education:
      "B.S. Business Administration at Georgia Tech; MBA at Oxford University",
    expertise:
      "She brings a background in the technology sector, with several years of experience in Washington, DC, where she worked as a Product Marketing Manager at a tech startup.",
    credentials: "",
    passion: "Traveling to new places and sustainable living",
    quote: "I love inside jokes. I hope to be a part of one someday.",
    quoteAuthor: "Michael Scott",
  },
  "luke-mitchell": {
    name: "Luke Mitchell",
    title: "Director of Partnerships",
    email: "luke.mitchell@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/davidlukemitchell/",
    image: "images/about/leader-luke-mitchell.webp",
    bio: "Luke is the Director of Partnerships at Guardian Service, where he brings a decade of experience focused on building and scaling strategic relationships with Real Estate Agents and Lenders. His passion is for every Concierge Partner to have a great experience while connecting others with Guardian Service.",
    education:
      "B.S., Sport Management at North Carolina State University; M.Ed., Higher Education Administration at North Carolina State University",
    expertise:
      "Building and Scaling Strategic Relationships, Driving Revenue Growth, Partnerships",
    credentials: "",
    passion:
      "Family, Friends, Traveling, and hoping my slice lands in the fairway",
    quote: "You just can't beat the person who never gives up.",
    quoteAuthor: "Babe Ruth",
  },
  "carlos-patino": {
    name: "Carlos Patiño",
    title: "VP of Platform Engineering",
    email: "carlos.patino@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/carlospatinoconte/",
    image: "images/about/leader-carlos-patino.webp",
    bio: "Carlos is VP of Platform Engineering at Guardian Service. He brings a decade of experience in various roles in technology, including product management at Salesforce; IT consulting with a specialty in cloud architecture at Microsoft and with a Microsoft partner; and working as an adjunct instructor of computer science. He is originally from Malaga, Spain.",
    education:
      "B.S., Mechanical Engineering & M.Eng., Systems Engineering at Cornell University. M.S., Computer Science & MBA at University of Chicago",
    expertise:
      "Cloud computing; software engineering; product management; enterprise IT",
    credentials: "",
    passion: "Soccer, and specifically goalkeeping.",
    quote:
      "Nothing would be done at all if one waited until one could do it so well that no one could find fault with it.",
    quoteAuthor: "John Henry Newman",
  },
  "lauren-schwenk": {
    name: "Lauren Schwenk",
    title: "Creative",
    email: "lauren.schwenk@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/laurenhaleyschwenk/",
    image: "images/about/leader-lauren-schwenk.webp",
    bio: "Lauren is a licensed personal insurance producer from North Carolina. She leads creative at Guardian Service, shaping the brand's visual identity across marketing, social media, and digital platforms. She brings more than a decade of experience in research, writing, and design to build creative that strengthens the brand and connects with consumers.",
    education:
      "B.A., Journalism & Mass Communication (Visual Communication) at University of North Carolina at Chapel Hill",
    expertise: "Marketing, Graphic Design, Market Research, Writing & Editing",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion: "Family, friends, and figuring out how to garden",
    quote:
      "Life moves pretty fast. If you don't stop and look around once in a while, you could miss it.",
    quoteAuthor: "Ferris Bueller",
  },
  "mike-stahl": {
    name: "Michael Stahl",
    title: "Executive Chairman",

    linkedin: "https://www.linkedin.com/in/michaelzstahl/",
    image: "images/about/leader-mike-stahl.webp",
    bio: "Michael, Executive Chairman of Guardian Service, is a seasoned C-level executive, board member, and strategic advisor with more than 20 years of experience driving growth across home services, franchising, healthcare, and insurance. At both publicly traded and private equity owned businesses, he has led organizations through successful turnarounds, acquisitions, brand transformations, and exits at SERVPRO (Blackstone-owned), UnitedHeathcare (NYSE: UNH), HealthMarkets (Blackstone-owned), Travelers (NYSE: TRV), and Kemper (NYSE: KMPR).",
    education:
      "B.S., Economics at The Wharton School, University of Pennsylvania",
    expertise:
      "Property & Casualty Insurance, Health Insurance, Marketing, Strategy, Customer Experience",
    credentials:
      "CPCU (Certified Property Casualty Underwriter), ARe (Associate in Reinsurance), AIAF (Associate in Insurance Accounting and Finance)",
    passion:
      "Anything and everything involving my four children. Kansas City sports.",
    quote:
      "We are forever defined by the people we have helped and the lives we have changed.",
    quoteAuthor: "Michael Stahl",
  },
  "john-thornton": {
    name: "John Thornton",
    title: "Board of Directors",

    linkedin: "https://www.linkedin.com/in/johnthornton/",
    image: "images/about/leader-john-thornton.webp",
    bio: "John is a strategic marketing leader and operator with a knack for turning complex growth challenges into clear, scalable wins. Blending data-driven insight with creative energy, he helps brands expand smarter — from multi-location consumer services to national growth strategies. On the board, John brings sharp strategy, a builder's mindset, and just enough spark to keep innovation and performance moving in sync.",
    education:
      "B.S., Commerce at the University of Virginia; MBA at Kellogg School of Management, Northwestern University",
    expertise:
      "Growth Strategy, Performance Marketing, Multi-Location Expansion, and Data-Driven Brand Building powered by Technology and AI.",
    credentials: "",
    passion:
      "Outside of work, John enjoys golf, pick-up basketball, and spending time with his family — especially the joys of being a girl dad.",
    quote:
      "I am a great believer in luck. And I find that the harder I work the more I have of it.",
    quoteAuthor: "Thomas Jefferson",
  },
  "heath-bradbury": {
    name: "Heath Bradbury",
    title: "VP of Marketing",
    email: "heath.bradbury@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/heathbradbury/",
    image: "images/about/leader-heath-bradbury.webp",
    bio: "Heath is a seasoned marketer and licensed insurance producer who's passionate about helping businesses connect with the people they serve. With more than two decades of experience spanning tech, retail, and home services, he blends strategic vision with practical insight to deliver real value for clients and partners alike.",
    education: "B.A., Business Economics at UC Santa Barbara",
    expertise: "Marketing, Home & Auto Insurance, Utility Line Warranties",
    credentials: "NC Licensed Insurance Producer, Personal Lines",
    passion: "Family & Fitness",
    quote: "Do or do not. There is no try.",
    quoteAuthor: "Yoda",
  },
  "kara-credle": {
    name: "Kara Credle",
    title: "Director of Member Engagement",
    email: "kara.credle@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/kara-marker-credle-980a03b6/",
    image: "images/about/leader-kara-credle.webp",
    bio: "Kara is a licensed personal lines insurance producer from North Carolina. In addition to her insurance expertise, she specializes in making insurance information accessible to everyone. She's passionate about breaking down the educational barriers in complex industries like insurance so everyone can understand what coverage they need and find the best balance of cost and coverage.",
    education:
      "B.A., Biology at University of North Carolina at Chapel Hill; M.A., English at University of North Carolina at Charlotte",
    expertise:
      "Car Insurance, Home Insurance, Umbrella Policies, Utility Line Warranties",
    credentials:
      "Licensed Insurance Producer, Personal Lines; Licensed Insurance Adjuster",
    passion: "Family, reading, and journaling",
    quote:
      "Don't ever, for any reason, do anything to anyone, for any reason ever, no matter what, no matter where, or who, or who you are with, or where you are going, or where you've been... ever, for any reason whatsoever...",
    quoteAuthor: "Michael Scott",
  },
  "seth-garff": {
    name: "Seth Garff",
    title: "Business Operations Associate",
    email: "seth.garff@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/seth-garff/",
    image: "images/about/leader-seth-garff.webp",
    bio: "Seth focuses on strategy and operations, leveraging technology and artificial intelligence to improve efficiency, empower the sales organization, and deliver exceptional value to customers. He is also a licensed personal lines insurance producer, bringing firsthand industry expertise to his role. Before transitioning into insurance, Seth worked in consulting, advising on large-scale strategic transformations for Fortune 50 energy companies.",
    education: "B.A., Psychology and Business at Brigham Young University",
    expertise: "Home Insurance, Car Insurance",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion:
      "Still chasing the perfect set — whether it's in the gym or on stage.",
    quote: "My life is good. Real good.",
    quoteAuthor: "Nacho Libre",
  },
  "joan-pierce": {
    name: "Joan Pierce",
    title: "Senior Accountant",
    email: "joan.pierce@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/joan-pierce-2911ba14/",
    image: "images/about/leader-joan-pierce.webp",
    bio: "Joan is a finance and operations professional with a strong background in problem-solving, cross-functional collaboration, and customer communication. She brings extensive experience in general accounting, supported by an analytical and organized approach. Known for her diligence and work ethic, Joan is dedicated to advancing company goals while fostering efficiency, teamwork, and a positive workplace culture.",
    education: "B.S., Chemistry at University of Pittsburgh",
    expertise:
      "General Accounting, Cross-Functional Collaboration, Process Optimization and Financial Reporting",
    credentials:
      "Bachelor of Science in Chemistry, with comprehensive professional experience in finance and operations",
    passion: "Spending time with family",
    quote: "Failure is success in progress.",
    quoteAuthor: "Albert Einstein",
  },
  "jack-rodriguez": {
    name: "Jack Rodriguez",
    title: "Operations Analyst",
    email: "jack.rodriguez@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/jack-rodriguez-16364b264/",
    image: "images/about/leader-jack-rodriguez.webp",
    bio: "Jack is a licensed personal lines insurance producer who works in operations and member experience. He's originally from Virginia but now resides in North Carolina. Beyond insurance expertise, Jack leverages his background in marketing, sales development, and data analytics to optimize internal processes and support strategic decision-making.",
    education: "B.S., Marketing Management at Virginia Tech",
    expertise:
      "Home Insurance, Auto Insurance, Sales Development, Client Support",
    credentials: "Licensed Insurance Producer, Personal Lines",
    passion:
      "Shredding guitar riffs off the clock and breaking down football plays on the weekend",
    quote: "Success is the sum of small efforts, repeated day in and day out.",
    quoteAuthor: "Robert Collier",
  },
  "jackson-waller": {
    name: "Jackson Waller",
    title: "Lead Data Engineer",
    email: "jackson.waller@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/jackson-waller/",
    image: "images/about/leader-jackson-waller.webp",
    bio: "Jackson is an experienced software engineer from Raleigh, North Carolina. He has a strong track record of building powerful systems that reliably serve millions of users, as well as ensuring that sensitive data is kept safe and secure. His experience spans financial systems, enterprise software and critical transportation.",
    education: "B.S., Physics at North Carolina State University",
    expertise: "Big data processing, data security, software development",
    credentials: "",
    passion: "Hiking and camping the woods of beautiful North Carolina",
    quote: "Do or do not. There is no try.",
    quoteAuthor: "Yoda",
  },
  "dana-wallace": {
    name: "Dana Wallace",
    title: "Director of Finance and Operations",
    email: "dana.wallace@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/dana-wallace-b2021217/",
    image: "images/about/leader-dana-wallace.webp",
    bio: "Dana is a seasoned finance and operations leader, managing accounting, compliance, and day-to-day financial processes. She helps ensure that our business runs smoothly and that partners and customers can rely on clear, accurate, and timely financial operations.",
    education: "B.B.A., Accounting at The College of William and Mary",
    expertise:
      "Finance Operations, Compliance, Accounting Systems, Operations Support",
    credentials: "",
    passion: "Spending quality time with friends and family",
    quote: "Failure to plan is a plan to fail.",
    quoteAuthor: "",
  },
  "kristi-ware": {
    name: "Kristi Ware",
    title: "Sales Manager",
    email: "kristi.ware@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/kristi-ware-2b93631a/",
    image: "images/about/leader-kristi-ware.webp",
    bio: "Kristi is a licensed insurance agent with a track record of driving results in the insurance industry. With extensive experience leading high-performing sales teams, she excels in developing key performance indicators and exceeding targets. Kristi's expertise spans new business sales, client retention, and operational efficiency, honed through leadership roles at Guardian Service, Policy Genius, and Allstate. Her strategic, results-driven approach makes her a valuable asset in the fast-paced insurance sector.",
    education: "B.S., Psychology at North Carolina State University",
    expertise:
      "Car Insurance, Home Insurance, Umbrella Policies, Renters Insurance, Boat insurance, Personal Articles Floater Insurance, Utility Line Warranties",
    credentials:
      "Licensed Insurance Producer, Property and Casualty; Licensed Insurance Producer, Life; Licensed Insurance Producer, Accident & Health or Sickness",
    passion:
      "Lazy Saturdays — coffee in hand, no agenda, enjoying an empty nest with my husband of 25 years. Of course I also treasure any time with my young adult children.",
    quote:
      "Things may happen and often do to people as brainy and footsy as you.",
    quoteAuthor: "Dr. Seuss",
  },
  "mitch-stella": {
    name: "Mitch Stella",
    title: "VP of Talent Acquisition",
    email: "mitch.stella@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/mitch-stella-b5099b7a/",
    image: "images/about/leader-mitch-stella.webp",
    bio: "Mitch is the Vice President of Talent Acquisition at Guardian Service. He leads the company’s talent strategy and hiring initiatives, partnering closely with leadership to scale high-performing teams that support Guardian’s growth and long-term vision. With a background that includes years as a producing insurance professional before transitioning into talent leadership, he brings a deep understanding of what drives success in revenue-focused organizations.",
    education: "BBA, Marketing at Texas A&M University",
    expertise: "Talent Acquisition, Sales, Sales Leadership",
    credentials: "",
    passion: "Spending time with my family and traveling.",
    quote:
      "It is not the critic who counts; not the man who points out how the strong man stumbles, or where the doer of deeds could have done them better. The credit belongs to the man who is actually in the arena.",
    quoteAuthor: "Theodore Roosevelt",
  },
  "rasesh-patel": {
    name: "Rasesh Patel",
    title: "Board of Directors",

    linkedin: "https://www.linkedin.com/in/rasesh-patel-a27a371/",
    image: "images/about/leader-rasesh-patel.webp",
    bio: "Rasesh is an operating executive and board leader with deep experience scaling consumer and technology-driven businesses. Most recently, he served as President of NRG Consumer, overseeing energy and smart home brands across North America. Prior to NRG, Rasesh held senior leadership roles at Vivint, AT&T, and DIRECTV, leading large-scale P&Ls across product, operations, technology, and customer experience. He brings a strong combination of operational rigor, digital transformation expertise, and customer-centric leadership.",
    education: "MBA, Finance at UCLA Anderson School of Management",
    expertise:
      "Product and Technology Strategy, Digital Transformation, Customer Experience, Scaling Multi-Channel Sales and Service Organizations",
    credentials: "",
    passion:
      "Outside of work, Rasesh enjoys hiking, travel, golf and spending quality time with friends and family.",
    quote: "This is your life.  Do what you love, and do it often.",
    quoteAuthor: "Holstee Manifesto",
  },
  "liz-galarza": {
    name: "Liz Galarza",
    title: "Sales Manager",
    email: "liz.galarza@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/lizsandra-galarza-4b55203a4/",
    image: "images/about/leader-liz-galarza.webp",
    bio: "Liz is a licensed General Lines insurance professional with a strong history of delivering performance-driven results. She has successfully led high-performing sales teams, established and tracked strategic KPIs, and consistently surpassed growth objectives. Her background includes expertise in new business acquisition, client retention, and operational improvement, gained through leadership roles at Guardian Service and Kin Insurance. With a strategic and analytical mindset, Liz thrives in dynamic, technology-driven insurance environments.",
    education: "B.A., Psychology at Interamerican University of Puerto Rico",
    expertise:
      "Home Insurance, Auto Insurance, Renters Insurance, Umbrella Insurance",
    credentials:
      "General Lines - Property and Casualty, General Lines - Life, Accident, Health and HMO",
    passion: "My family, my two Australian Shepherds, and Salsa Dancing",
    quote: "Work hard, be kind, and amazing things will happen.",
    quoteAuthor: "Conan O'Brien",
  },
  "lindsey-yannoni": {
    name: "Lindsey Yannoni",
    title: "Member Experience Associate",
    email: "lindsey.yannoni@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/lindsey-yannoni-3a6358225/",
    image: "images/about/leader-lindsey-yannoni.webp",
    bio: "Lindsey is a recent college graduate from Raleigh, North Carolina with a strong background in communication and interpersonal relations developed through her experience in the leisure and hospitality sector. She is passionate about delivering exceptional customer service.",
    education: "B.S. Economics at East Carolina University",
    expertise: "",
    credentials: "",
    passion: "Broadway musicals and time at the beach",
    quote:
      "A great attitude is not the result of success; success is the result of a great attitude.",
    quoteAuthor: "Earl Nightingale",
  },
  "mike-schmitt": {
    name: "Mike Schmitt",
    title: "Sales Manager",
    email: "mike.schmitt@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/mike-schmitt-cpcu-33106794/",
    image: "images/about/leader-mike-schmitt.webp",
    bio: "Mike is a licensed insurance producer from North Carolina. With over a decade of experience leading sales and service operations across the insurance and tech industries, Mike brings deep expertise in developing high-performing teams, driving growth, and creating outstanding customer experiences.",
    education: "B.A., Psychology at the University of North Carolina",
    expertise:
      "Auto Insurance, Home Insurance, Personal Umbrella coverage, Renter's Insurance, Condo Insurance",
    credentials:
      "Licensed Insurance Producer, P&C; Chartered Property Casualty Underwriter (CPCU)",
    passion:
      "Spending time with family, watching NFL football, and doing my best BBQ Pitmaster impression",
    quote: "Nothing great was ever achieved without enthusiasm.",
    quoteAuthor: "Ralph Waldo Emerson",
  },
  "sierra-dodds": {
    name: "Sierra Dodds",
    title: "Member Experience Associate",
    email: "sierra.dodds@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/sierra-dodds-545b29396/",
    image: "images/about/leader-sierra-dodds.webp",
    bio: "Sierra is a licensed Personal and Commercial Lines CSR in the member experience department. Originally from Colorado she now calls the Carolinas home and enjoys delivering exceptional service to our members. She leverages a customer-first approach to guide members through their insurance journey, ensuring informed decisions and tailored solutions.",
    education: "B.A., History at College of Charleston",
    expertise: "Home Insurance, Auto Insurance",
    credentials:
      "Licensed Insurance Producer, Personal Lines and Commercial Lines",
    passion: "Spending a day with my dog and working on my crafts",
    quote:
      "People will forget what you said, people will forget what you did, but people will never forget how you made them feel.",
    quoteAuthor: "Maya Angelou",
  },
  "molly-oconnor": {
    name: "Molly O'Connor",
    title: "President of Community Impact",
    email: "molly.oconnor@three-ships.com",
    linkedin: "https://www.linkedin.com/in/mollydwyer/",
    image: "images/about/leader-molly-oconnor.webp",
    bio: "As President of 3S Community Impact, Molly is operating a community impact arm of Three Ships that models the discipline, focus, and rigor of our high-growth businesses.\n\n Molly was previously a Managing Director at Three Ships and led the home business from 2017-2020. Prior to Three Ships, Molly was a global corporate attorney at the Raleigh office of K&L Gates and the New York City office of Milbank. She holds both her undergraduate and law degrees from Georgetown University.\n\n Molly is passionate about our local community. She is on the board of directors at the United Way of the Greater Triangle. She was a former board member and served as Vice President and Secretary of Preservation Durham, Durham's non-profit historic preservation society. She was the recipient of the Legal Aid Society's Pro Bono Publico Award for supporting low-income micro-entrepreneurs and non-profit organizations.",
    education:
      "B.A., English and Art History at Georgetown University, J.D. at Georgetown University Law Center",
    expertise: "",
    credentials: "",
    passion: "Tennis, family travels, great hikes",
    quote: "In a world where you can be anything, be kind.",
    quoteAuthor: "",
  },
  "peyton-helou": {
    name: "Peyton Helou",
    title: "Recruiter",
    email: "peyton.helou@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/peyton-h44/",
    image: "images/about/leader-peyton-helou.webp",
    bio: "Peyton is a recruiting professional with experience in corporate talent acquisition. Originally from Northern Virginia and a graduate of UNC Wilmington, she brings a thoughtful, people-focused approach to supporting hiring efforts and helping foster a positive and collaborative culture at Guardian Service.",
    education: "B.A., International Studies at UNC Wilmington",
    expertise: "Corporate Recruitment",
    credentials: "",
    passion: "Traveling and spending time with family",
    quote: "It's not what you look at that matters, it's what you see.",
    quoteAuthor: "Henry David Thoreau",
  },
  "tommy-noles": {
    name: "Tommy Noles",
    title: "Member Service Associate",
    email: "tommy.noles@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/thomas-noles-53b368319/",
    image: "images/about/leader-tommy-noles.webp",
    bio: "Tommy is originally from Smithfield, North Carolina, and now resides in Kenly, North Carolina. He obtained his BSBA in Business Management from Western Carolina University. With strong academic performance and hands-on work experience, Thomas has built a reputation as a dependable, hard-working, and adaptable team member. He has spent several years working in customer-facing roles at Food Lion and the Smithfield Recreation & Aquatics Center, where he strengthened his skills in leadership and customer service. He brings those experiences into his current role as a Member Experience Representative at Guardian Service in Raleigh, NC. Whether assisting customers or handling administrative tasks, Thomas brings a positive attitude and a commitment to doing the job well. He is motivated, loyal, and always ready to take on new responsibilities as he continues building his professional career.",
    education:
      "BSBA, Business Management at Western Carolina University; AA at Johnston Community College",
    expertise: "",
    credentials: "",
    passion:
      "Avid gym goer, dabble in video games (MLB the Show, Call of Duty, Rainbow Six Siege), Sight Seeing (Hiking, Beaching, Golfing)",
    quote: "It can either be one day, or day one.",
    quoteAuthor: "",
  },
  "robbie-ohan": {
    name: "Robbie O'Han",
    title: "VP of Finance & Strategy",
    email: "robbie.ohan@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/robert-o-han/",
    image: "images/careers/Shield - Robbie O.webp",
    bio: "Robbie supports the finance & strategy function of the business. He brings experience helping businesses with strategy, capital allocation, and financial planning.",
    education: "B.S.B.A., Finance at UNC Kenan-Flagler Business School",
    quote:
      "Good people are happy when something good happens to someone else.",
    quoteAuthor: "Dean Smith",
  },
  "jeremy-chasak": {
    name: "Jeremy Chasak",
    title: "Member Experience Manager",
    email: "jeremy.chasak@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/jeremy-chasak-ais-prc-1ba7804b/",
    image: "images/about/leader-jeremy-chasak.webp",
    bio: "Jeremy, a Raleigh native, has witnessed his city's growth and brings that same spirit of progress to his work in the insurance industry. With experience writing policies in all fifty states, he stays current on industry trends to provide informed, reliable guidance. Driven by both sales success and client satisfaction, Jeremy is dedicated to finding every member the best possible coverage and value.",
    education:
      "B.S., Business Administration and Management at Shaw University; Associate in Insurance Services at The Institute; Professional Risk Consultant at The Institute",
    expertise:
      "Auto Insurance, Homeowners, Landlord Policies, Vacant Homes, Renters, Boats, ATV's, RV's, Motorhomes, Mobile/Manufactured Homes, Renters Insurance, Umbrella Insurance, Personal Articles Insurance",
    credentials:
      "Personal Lines, Property & Casualty, Life, Accident and Health or Sickness, Medicare Supplemental/Long Term Care",
    passion:
      "Being a family man, volunteering at my church and my kids school, huge Alabama Crimson Tide supporter, avid golfer and sports junky. Also known as an amateur grill master.",
    quote:
      "What happened yesterday is history. What happens tomorrow is a mystery. What we do today makes a difference.",
    quoteAuthor: "Nick Saban",
  },
  "meena-kaundinya": {
    name: "Meena Kaundinya",
    title: "Marketing Associate",
    email: "meena.kaundinya@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/meena-kaundinya-nc/",
    image: "images/careers/Shield - Meena Kaundinya.webp",
    bio: "Meena is a Marketing Associate at Guardian Service, bringing a background in startup and agency marketing to her work supporting the team's marketing strategy and execution. She focuses on building brand presence and driving engagement through effective content and messaging.",
    education: "B.S.B.A., University of North Carolina at Chapel Hill",
    expertise: "Marketing Strategy, Brand & Content",
    credentials: "",
    passion: "Traveling, cooking, and spending time with family and friends",
    quote: "Not all those who wander are lost.",
    quoteAuthor: "J.R.R. Tolkien",
  },
  "rachel-kelsey": {
    name: "Rachel Kelsey",
    title: "Recruiter",
    email: "rachel.kelsey@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/rachel-kelsey-9b300919b/",
    image: "images/careers/Shield - Rachel Kelsey.webp",
    bio: "Rachel is a Recruiter originally from Louisville, Kentucky. She brings a dynamic professional background that blends recruiting and business development. She utilizes a relationship-driven approach to support ongoing hiring efforts and identify top-tier talent. With a BA in Communication and Spanish, she is dedicated to fostering a positive, collaborative culture where teams can thrive.",
    education: "B.A. Communications & Spanish at Denison University",
    expertise: "Corporate Recruitment",
    credentials: "",
    passion:
      "Spending time with friends and family, trying new restaurants, playing pickleball",
    quote: "The most wasted of days is one without laughter.",
    quoteAuthor: "E.E. Cummings",
  },
  "emma-reid": {
    name: "Emma Reid",
    title: "Member Service Associate",
    email: "emma.reid@guardianservice.com",
    linkedin: "",
    image: "images/careers/Shield - Emma Reid.webp",
    bio: "Emma is a Member Experience Associate from Raleigh, North Carolina. She brings experience from previous roles in customer service, documentation, and administration. Her goal is to help promote an organized and efficient workplace for both her customers and coworkers.",
    education:
      "B.A., Design Studies, Minor in Business Administration at NC State University",
    expertise: "",
    credentials: "",
    passion: "Reading, Making art, Going to thrift stores and flea markets",
    quote: "Do it tired, do it alone, do it scared. You're almost there.",
    quoteAuthor: "",
  },
  "ana-berrizbeitia": {
    name: "Ana Berrizbeitia",
    title: "Senior Member Experience Associate",
    email: "ana.berrizbeitia@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/ana-berrizbeitia-525a10414/",
    image: "images/careers/Shield - Ana Berrizbeitia.webp",
    bio: "Originally from Caracas, Venezuela, Ana has proudly called North Carolina home for the past six years. Since beginning her career in the insurance industry in 2020, she has become a licensed Property & Casualty (P&C) insurance producer dedicated to helping individuals and families protect what matters most. Ana is passionate about educating her clients, making insurance easy to understand, and building lasting relationships through personalized service and genuine care.",
    education: "Bachelor of Business at NE University in Caracas, VE",
    expertise: "Home Insurance, Car Insurance, Quoting, Underwriting",
    credentials: "Licensed Insurance Producer, Property & Casualty",
    passion: "I like to read, cook and spend time with my dogs",
    quote: "If eating cake is wrong, I don't wanna be right!",
    quoteAuthor: "Lorelai Gilmore",
  },
  "minda-flores": {
    name: "Minda Flores",
    title: "Member Coverage Advisor",
    email: "arminda.flores@guardianservice.com",
    linkedin: "https://www.linkedin.com/in/arminda-flores-0498a0b6/",
    image: "images/careers/Shield - Minda Flores.webp",
    bio: "Minda is a licensed property and casualty insurance professional based in Seguin, Texas. She brings 15 years of industry experience and is licensed to serve customers in all 50 states.",
    education: "Business Administration at University of Phoenix",
    expertise: "Personal Lines Insurance, Home & Auto",
    credentials: "Licensed Insurance Producer, Property & Casualty",
    passion:
      'Watching my "roommates" become successful. I\'m proud to have 2 starting college this year at Texas A&M and Texas State as well as part of the Army Reserve',
    quote: "Don't be bitter, be better.",
    quoteAuthor: "",
  },
  "shawn-terrell": {
    name: "Shawn Terrell",
    title: "Member Service Associate",
    email: "shawn.terrell@guardianservice.com",
    linkedin: "",
    image: "images/careers/Shield - Shawn Terrell.webp",
    bio: "A licensed personal lines insurance producer specializing in member experience, Shawn brings a wealth of expertise from her background at Cisco Systems, Fidelity, and MetLife. Originally from New York and now based in Morrisville, North Carolina. She has excelled in diverse roles—ranging from Military Mortgage Advisor, Customer Care Consultant, Home Loan Specialist, Deal Manager to Customer Service Manager—to sharpen her leadership and service skills. Today, she leverages this extensive background as a Member Experience Associate at Guardian Service in Raleigh, NC.",
    education: "B.A., Psychology at The City College of New York",
    expertise:
      "Home Insurance, Auto Insurance, Life Insurance, Mortgage Loans, Retirement Investments, Client Support",
    credentials:
      "Licensed Insurance Producer, Personal Lines, Licensed Registered Securities Representative (FINRA SIE, SERIES 6), Licensed (NMLS) Mortgage Professional",
    passion: "Family, Cooking, Chess, Backgammon, and Cycling/Spin Class",
    quote:
      "Change the way you look at things, and the things you look at change.",
    quoteAuthor: "Wayne Dyer",
  },
};
